import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Iconsax } from "@components-common";
import { toast } from 'react-toastify';
import AddUserModal from './AddUserModal';
import { actCreateIddsiAccount, actReportUsers } from "@actions";

// Styled components
const AddButton = styled.button`
  border-radius: 8px;
  border: 1px solid #0E7AA8;
  background: #0E7AA8;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 10px 16px;
  color: #FFF;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 56px;
  box-sizing: border-box;

  svg {
    margin-right: 8px;
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

const AddNewUser = () => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  
  // Get data from Redux store
  const createAccountState = useSelector(state => state.createIddsiAccount || {});
  const { isLoading, data: createAccountData, error } = createAccountState;

  const toggleModal = () => {
    setModal(prev => {
      if (prev) {
        // Reset when closing modal
        setHasSubmitted(false);
      }
      return !prev;
    });
  };

  const handleSubmit = (values) => {
    setHasSubmitted(true);
    const params = {
      firstname: values.first_name,
      lastname: values.last_name,
      email: values.email,
      password: values.password,
      ward: values.ward || ""
    };
    
    dispatch(actCreateIddsiAccount(params));
  };

  // Handle success after account creation
  useEffect(() => {
    if (createAccountData && !isLoading && hasSubmitted && modal) {
      // Account created successfully
      toast.success("User account created successfully!", {
        position: toast.POSITION.TOP_RIGHT
      });
      toggleModal();
      // Refresh user list
      dispatch(actReportUsers());
      setHasSubmitted(false);
    }
  }, [createAccountData, isLoading, hasSubmitted, modal, dispatch]);

  // Handle error after account creation
  useEffect(() => {
    if (error && !isLoading && hasSubmitted && modal) {
      // Show error message
      toast.error(error || "Failed to create user account", {
        position: toast.POSITION.TOP_RIGHT
      });
      setHasSubmitted(false);
    }
  }, [error, isLoading, hasSubmitted, modal]);

  return (
    <>
      <AddButton onClick={toggleModal}>
        <Iconsax iconName="plus" fill="#fff" size={25} />
        <span>Add New User</span>
      </AddButton>
      <AddUserModal
        isOpen={modal}
        toggle={toggleModal}
        isLoading={isLoading}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default AddNewUser;

